import type { PreviewOrderQuoteOfferFeasibilityInput } from '@codezo/graphql';
import type { Pricing } from './offer-types';

/**
 * Build the feasibility-preview input for one quantity tier, or `null` to stay
 * idle. Always previews (like admin) — with no deadline the API still returns a
 * projected window, which reads as a neutral "Arrives {window}".
 */
export function buildTierFeasibilityInput(
	pricing: Pricing | undefined,
	deadline: string | null,
	acceptDeadline: string | null
): PreviewOrderQuoteOfferFeasibilityInput | null {
	if (!pricing) return null;
	return {
		minProductionDays: pricing.minProductionDays ?? null,
		maxProductionDays: pricing.maxProductionDays ?? null,
		deadline: deadline ?? undefined,
		acceptDeadline: acceptDeadline ?? undefined,
		/* Splits are left out: the result comes back keyed by shipping method, and
		   a split's method is DERIVED from its first leg. Previewing one puts a
		   second entry under that method in the response, silently overwriting the
		   real option's — so the plain method would show the split's dates. A
		   split's own arrival is on its saved row and on each of its parts. */
		deliveries: (pricing.deliveries ?? [])
			.filter((d) => !d.isSplit)
			.map((d) => ({
				shippingMethod: d.shippingMethod,
				deliveryDaysMin: d.deliveryDaysMin,
				deliveryDaysMax: d.deliveryDaysMax,
			})),
	};
}
